<img alt="Error" width="227" height="185" src="assets/img/curious-robot.svg" class="error__img" />
<div *ngIf="showTitle" class="error__title">Oops, There is an error!</div>
<div>
  <ng-container *ngIf="errorDescription else defaultErrorDescription">
    <p class="error__text error__slot">
     {{errorDescription}}
    </p>
  </ng-container>

  <button (click)="tryAgain()" [disabled]="isRetrying" class="primary" mat-raised-button>
    Retry
    <mat-spinner *ngIf="isRetrying" diameter="18"></mat-spinner>
  </button>
</div>

<ng-template #defaultErrorDescription>
  <p class="error__text error__default">
    We've encountered an unexpected error with the application.
    Try reloading the data.
    If that doesn't solve the issue, please contact your CoachBot administrator.
  </p>
</ng-template>
